import React, { FC } from 'react'
import Modal from '@material-ui/core/Modal'
import classes from '../../../nlp/components/knowledgeBase/SourcesTable/styles.module.scss'
import { CrossIcon } from 'uiKit/icons/CrossIcon'
import SubmitButton from 'uiKit/buttons/SubmitButton'
import { UserType } from '../../model/usersModel'

interface Props {
  open: boolean
  onClose: () => void
  onDelete: (source: any) => void
  selectedUser: UserType
}

export const DeleteUserModal: FC<Props> = ({ open, onClose, onDelete, selectedUser }) => {

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.container}>
        <p className={classes.title}>
          Are you sure you want to remove access to CareBrain from {selectedUser.first_name}?
        </p>
        <div className={classes.closeButton} onClick={onClose}>
          <CrossIcon color={'var(--color-spun-pearl-grey)'} />
        </div>
        <div className={classes.buttonsWrap}>
          <div className={classes.deleteButton} onClick={onDelete}>
            Delete
          </div>
          <SubmitButton onClick={onClose} title="Cancel" />
        </div>
      </div>
    </Modal>
  )
}
